/* eslint-disable react/prop-types */

import React from 'react';

function HashtagActionButtons({
 hashtag, hashtagUsageCeiling, onFollow, onMute, onBlock, onRemoveForceFollow,
}) {
  const isHighVolume = hashtag.hashtag_usage_count > hashtagUsageCeiling;
  const isForceFollowed = hashtag.force_followed_at != null;

  return (
    <div className="btn-group" role="group" aria-label="Hashtag notification options">
      {/* Follow button */}
      <button
        type="button"
        className={`btn ${
          (hashtag.follow_status === 'follow' && !isHighVolume) || isForceFollowed
            ? 'btn-primary'
            : 'btn-outline-primary'
        }`}
        onClick={() => {
          if (
            (hashtag.follow_status === 'follow' && !isForceFollowed && isHighVolume)
            || hashtag.follow_status === 'block'
            || hashtag.follow_status === 'mute'
            || hashtag.follow_status === null
          ) {
            onFollow(hashtag.hashtag_id, isHighVolume);
          }
        }}
        title="Follow"
      >
        <i className="fa-solid fa-bell" />
      </button>

      {/* Mute button */}
      <button
        type="button"
        className={`btn ${
          hashtag.follow_status === 'mute'
          || hashtag.follow_status === null
          || (isHighVolume && !isForceFollowed && hashtag.follow_status !== 'block')
            ? 'btn-primary'
            : 'btn-outline-primary'
        }`}
        onClick={() => {
          // If this is a force-followed hashtag, clicking mute only removes force-follow
          if (isForceFollowed) {
            onRemoveForceFollow(hashtag.hashtag_id);
          // Normal mute behavior for other cases
          } else if (hashtag.follow_status !== 'mute' && hashtag.follow_status !== null) {
            onMute(hashtag.hashtag_id);
          }
        }}
        title="Mute"
      >
        <i className="fa-solid fa-bell-slash" />
      </button>

      {/* Block button */}
      <button
        type="button"
        className={`btn ${hashtag.follow_status === 'block' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => {
          if (hashtag.follow_status !== 'block') {
            onBlock(hashtag.hashtag_id);
          }
        }}
        title="Block"
      >
        <i className="fa-solid fa-ban" />
      </button>
    </div>
  );
}

export default HashtagActionButtons;
